import {exportPage} from './importExport'
import {pointerUtils, type DAL, type ExtensionAPI} from '@wix/document-manager-core'
import type {DocumentExternalPageUpdate, DocumentExternalUpdate, PageUpdateInfo} from '@wix/anyide-cli-types'
import {VIEW_MODES} from '../../../constants/constants'
import type {CompRef} from '@wix/document-services-types'
import type {PageExtensionAPI} from '../../page'

const {getCompPointer} = pointerUtils

const buildDocumentPageInfo = (pagePointer: CompRef, extensionAPI: ExtensionAPI): PageUpdateInfo => {
    const {page} = extensionAPI as PageExtensionAPI

    return {
        title: page.getPageTitle(pagePointer.id) ?? pagePointer.id,
        type: 'Page'
    }
}

const buildDocumentPageUpdate = (
    pagePointer: CompRef,
    dal: DAL,
    extensionAPI: ExtensionAPI
): DocumentExternalPageUpdate => {
    const data = exportPage(pagePointer, extensionAPI, dal)
    if (!data) {
        return null
    }

    const info = buildDocumentPageInfo(pagePointer, extensionAPI)

    return {
        data,
        info
    }
}

export const buildDocumentUpdate = (
    pageIds: string[],
    dal: DAL,
    extensionAPI: ExtensionAPI
): DocumentExternalUpdate => {
    const documentUpdate: DocumentExternalUpdate = {pages: {}}

    for (const pageId of pageIds) {
        const pagePointer = getCompPointer(pageId, VIEW_MODES.DESKTOP)
        documentUpdate.pages[pageId] = buildDocumentPageUpdate(pagePointer, dal, extensionAPI)
    }

    return documentUpdate
}
